import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-[#F3EDE3] text-[#0A0A0A] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-lg w-full bg-white border border-[#DCD3C3] p-10 text-center"
      >
        <XCircle className="w-12 h-12 mx-auto text-[#5C564C]" />
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#B38728] mt-6">Checkout Cancelled</p>
        <h1 className="font-serif text-4xl mt-3" data-testid="payment-cancel-message">The vault stays open</h1>
        <p className="text-[#5C564C] mt-4 text-sm leading-relaxed">
          No charge was made. The item is still in stock — for now. Rare pieces move fast.
        </p>
        <Link
          to="/"
          data-testid="payment-cancel-home-link"
          className="inline-block mt-8 bg-[#0A0A0A] text-[#F3EDE3] px-8 py-3 text-xs font-mono uppercase tracking-[0.25em] hover:bg-[#B38728] hover:text-[#0A0A0A] transition-colors"
        >
          Return to Stock
        </Link>
      </motion.div>
    </main>
  );
}
